import { Component, OnInit } from '@angular/core';
import { MaPlatePreparationService } from '../ma-plate-preparation/ma-plate-preparation.service';
import { MasterDataService } from '../masterdata/masterdata.service';
import { SenderDTO } from '../masterdata/models/sender-dto';
import { WorkFlow } from '../masterdata/models/workFlow';
import { MessagesService } from '../messages/messages.service';
import { Plate } from '../models/plate';
import { ProcessStepStage } from '../models/process-step-stages';
import { Sample } from '../models/sample';
import { Step } from '../models/step';
import { Storage } from './../../app/models/storage';
import { ErrorHandler } from '../utils/error-handler';
import { PlateStatus, ProcessStep } from '../models/process-step';
import { MaStorageService } from '../ma-storage/ma-storage.service';
import { ProcessFlow } from '../masterdata/models/processFlow';
import { ActivatedRoute } from '@angular/router';
import { AnnouncedService } from '../apg-announced/services/announced.service';
import { MultiPlateUpdate } from '../ma-plate-preparation/multiplate-update-dto';
import { saveAs as saveByFileSaver } from "file-saver";
import { AlreadyAnnouncedSamplesDTO } from '../models/alreadyAnnouncedSamplesDTO';
import * as XLSX from 'xlsx';
import { SRCSampleDTO } from '../models/SRCSampleDTO';
import { PlateListDTO } from '../dto/plateListDTO';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-ma-reception',
  templateUrl: './ma-reception.component.html',
  styleUrls: ['./ma-reception.component.css']
})
export class MaReceptionComponent implements OnInit {
  errorHandler: ErrorHandler = new ErrorHandler;

  loading: boolean;
  blocked: boolean;
  selectedLabId: string;
  puid: string;
  plateToSearch: string = "";
  sampleToSearch: string = "";
  workFlowList = [];
  workFlowData: WorkFlow[] = [];
  mapOfSenders = new Map();
  customerList: any[] = [];
  selectedSender: SenderDTO;

  plates: Plate[] = []
  selectedPlate: Plate;
  selectedPlateStepsMap: Map<string, Step>;
  plate: Plate;
  selectedSamples: Sample[];
  sample: Sample;

  scannedBarcodeToShow: string = "";

  selectedTabIndex: number = 0;

  storageList: Array<any> =[];
  selectedStorage: Storage;
  selectedProcessFlows: ProcessFlow[];
  processFlowData: ProcessFlow[];

  index: number = 0;
  scannedPlateID: string = null;
  plateSelectionList =[];
  selectedPlateMap = new Map<string,  Sample[]>();
  plateList: string[] =[];
  receivePlatePlateID: string = "";
  isPlateReceptionOn: boolean = true;
  isSampleScanOn: boolean = true;
  selectedPlateStatus = '';
  dateSelected: Date;
  exported : boolean = false;
  tableSelectedRow: Plate;
  alreadyAnnouncedSamplesDTO:AlreadyAnnouncedSamplesDTO;
  updatedSamplesInfo: any;
  storagePlateAndStorageLocation: Map<string, any>;
  updatedAnnouncedSamples: AlreadyAnnouncedSamplesDTO[] = [];
  activatedSamplesHeaderVisible: boolean = false;
  srcExcelHeaderVisible: boolean = false;

  showDueDate = false;

  constructor(private activatedroute: ActivatedRoute, private masterDataService: MasterDataService,
    private _maStorageService: MaStorageService, private announcementService:AnnouncedService,
    private _messagesService: MessagesService, private platePreparationService: MaPlatePreparationService) { }

  ngOnInit() {
    this.puid = localStorage.getItem("PUID");
    this.selectedPlate = new Plate();
    this.selectedPlate.samples = []
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.getWorkFlowList();
    this.populateSendersInMap();
    this.getAnnounedPlates();
    this.receiveButtonDisable();
    this.getStorageLocations();
    this.getProcessFlowList();
    this.fetchStoragePlatesList();
    this.fetchfSRCErrorSamplesList();
    this.selectedPlateStepsMap = new Map();

    this.activatedroute.params.subscribe(
      params => {
        this.scannedPlateID = params['id'];
        let tabIndex = params['tab'];
        if(this.scannedPlateID && tabIndex) {
          this.isPlateReceptionOn = true;
          this.isSampleScanOn = true;
          this.onTabChange({index : +tabIndex});
          if(this.isPlateReceptionOn && this.index == 0 && (this.scannedPlateID || this.scannedPlateID.trim() == '')) {
            this.searchForPlateAction(this.scannedPlateID, false);
          }
        }
      }
    );
    this.dateSelected = new Date(new Date().setDate(new Date().getDate()-1));
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  fetchfSRCErrorSamplesList() {
    this.announcementService.doRemovedSRCSamplesExist(this.selectedLabId).subscribe({
      next : (result) => {
        this.srcExcelHeaderVisible = result.data;
      },
      error: (_error: any) => {
        this._messagesService.addErrorMessage({ severity: 'error',
        summary: 'Back-end Error',
        detail: 'Failed to fetch sample info. Please refresh the page. Contact support if refresh does not work.' });
      }
    });
  }

  preparePlateSearchDTO(labId: string, type?: string, status?: string, processFlowName?: string, fromDate?: Date): PlateListDTO {
    const plateListDTO = new PlateListDTO();
    plateListDTO.labId = labId;
    if (typeof type !== 'undefined') {
      plateListDTO.type = type;
    }
    if (typeof status !== 'undefined') {
      plateListDTO.status = status;
    }
    if (typeof processFlowName !== 'undefined') {
      plateListDTO.processFlowName = processFlowName;
    }
    if (fromDate !== undefined && fromDate !== null) {
      plateListDTO.fromDate = formatDate(fromDate, 'yyyy-MM-dd', 'en-US')
    }
    return plateListDTO;
  }

  getAnnounedPlates() {
    this.loading = true;
    let statuses = [PlateStatus.ANNOUNCED, PlateStatus.RECEPTION_COMPLETED].join(',');
    this.platePreparationService.fetchPlates(this.preparePlateSearchDTO(this.selectedLabId, "PLATE", statuses)).subscribe({
      next : (result) => {
        this.loading = false;
        this.plates = result;
        if(this.selectedPlate.plateID != null){
          for(let i=0; i<this.plates.length; i++){
            if(this.selectedPlate.plateID == this.plates[i].plateID){
              this.tableSelectedRow = this.plates[i]
              break
            }
          }
        }
      },
      error: (error: any) => {
        this.loading = false;
        console.log("Error in fetching received plates ", error);
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch plates',
          detail: 'Some issue in pulling the plates info, please try again'
        })
      }
    })
  }

  getSelectedWorkflow(){
    let selectedWorkFlowData: WorkFlow[] = this.workFlowData.filter(e=> e.displayName === this.selectedPlate.workFlow );
    if(!selectedWorkFlowData || selectedWorkFlowData.length ==0) {
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Work flow Not Found', detail: 'Please configure Work flow '+ this.selectedPlate.workFlow + ' to continue with this batch.' });
    }else{
      this.selectedPlate.workFlow = selectedWorkFlowData[0].workFlowName;
    }
  }

  getWorkFlowList() {
    this.blocked = true;
    this.masterDataService.getConfigList(this.selectedLabId, "workflow", 0, 100, true).subscribe(results => {
      this.blocked = false;
      this.workFlowData = results.data;
      this.workFlowData.forEach(e=>{
        this.workFlowList.push({label: e.workFlowName, value: e.workFlowName});
      });
    },
    (error: any) => {
      this.blocked = false;
      this.showError(error);
    });

  }

  getProcessFlowList(){
    this.masterDataService.getConfigList(this.selectedLabId, "processFlow", 0, 100, true).subscribe(
      results => {
        this.processFlowData = results.data;
        this.isICBFWorkflow();
      }
    )
  }

  populateSendersInMap() {
    this.masterDataService.getConfigList(this.selectedLabId, "masender", 0, 100, true).subscribe(
      (result)=>{
        var senders: SenderDTO[] = result.data;
        if(!senders){
          console.log("No senders found !!")
        }
        senders.forEach(sender=>{
          this.mapOfSenders.set(sender.senderName, sender);
          let tempSender: SenderDTO = sender;
          let labelValue = tempSender.senderShortName ? tempSender.senderShortName : sender.senderName;
          this.customerList.push({label: labelValue, value: sender.senderName});
        })
      },error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }

  getSelectedSender() {
    this.selectedSender = this.mapOfSenders.get(this.selectedPlate.sender);
    if (!this.selectedSender) {
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Sender Not Found', detail: 'Please configure Sender ' + this.selectedPlate.sender + ' to continue with this batch.' });
      return;
    }
  }

  setPlateSender() {
    if (this.customerList.length == 1) {
      this.selectedPlate.sender = this.customerList[0].value;

    } else {
      this.selectedPlate.sender = null;
    }
  }

  isICBFWorkflow(){
    let selectedWorkflow = JSON.parse(localStorage.getItem("selectedWorkFlow"));
    this.selectedProcessFlows = []
    if(selectedWorkflow.processFlow == null || selectedWorkflow.processFlow.length==0 || this.processFlowData == undefined || this.processFlowData == null){
      return;
    }

    let selectedProcessFlowNames = selectedWorkflow.processFlow;
    this.processFlowData.forEach(
      processFlow => {
        if(selectedProcessFlowNames.includes(processFlow.processFlowName))
          this.selectedProcessFlows.push(processFlow);
      }
    );

    if(this.selectedProcessFlows.length == 0){
      return;
    }

    this.isPlateReceptionOn = false;
    this.isSampleScanOn = false;
    for(let i=0; i<this.selectedProcessFlows.length; i++){
      if(this.selectedProcessFlows[i].manualReception && this.selectedProcessFlows[i].singleReception){
        this.isSampleScanOn = true;
      }
      if(this.selectedProcessFlows[i].plateReception){
        this.isPlateReceptionOn = true;
      }
    }
  }

  receivePlate(){
    this.updateProcessStep(ProcessStep.RECEIVE_PLATE, ProcessStepStage.start)
    this.selectedPlate.status="RECEIVED";
    this.updateMultiPlates();
  }

  storePlate(){
    this.updateProcessStep(ProcessStep.STORE_PLATE, ProcessStepStage.start)
    this.selectedPlate.status="STORED";
    this.updateMultiPlates();
    this.addPlateToStorage();
  }

  updateProcessStep(step: string, stage: ProcessStepStage){
    if(this.selectedPlateStepsMap.has(step)){
      var existingStep = this.selectedPlate.processSteps.find(s => s.step == step);
      if(ProcessStepStage.start==stage){
        existingStep.startTimeStamp = new Date();
        existingStep.startPUID = this.puid;
        existingStep.liquidHandler = '';
      }else{
        existingStep.endTimeStamp = new Date();
        existingStep.endPUID = this.puid;
      }
      //server is forcing to put default/dummy values, otherwise it is throwing 500
      existingStep.action = [];
    }else{
      var newStep = new Step();
      newStep.step = step;
      if(ProcessStepStage.start==stage){
        newStep.startTimeStamp = new Date();
        newStep.startPUID = this.puid;
        newStep.liquidHandler = '';
        //server is forcing to put default/dummy values, otherwise it is throwing 500
        newStep.endPUID = "";
        newStep.endTimeStamp = null;
      }else{
        newStep.endTimeStamp = new Date();
        newStep.endPUID= this.puid;
      }
      //temp: harcoding action step as [] to avoid server 500
      newStep.action = [];
      newStep.chemicals = [];
      if(!this.selectedPlate.processSteps || this.selectedPlate.processSteps==null)
        this.selectedPlate.processSteps = []
      this.selectedPlate.processSteps.push(newStep)
    }
  }

  isPUIDPresent() {
    if (this.puid != null && this.puid != undefined && this.puid != '') {
      return true;
    }
    return false;
  }

  updateOFHSamples(){
    let sampleIds = [];
    this.selectedPlateMap.forEach( value => {
      value.forEach(sample => {
        sampleIds.push(sample._id);
      })
    })
    if(sampleIds.length == 0){
      return;
    }
    let request = {};
    request['labId'] = this.selectedPlate.labID;
    request['sampleIds'] = sampleIds;
    request['puid'] = this.puid;
    this.blocked = true;
    this.platePreparationService.updateOFHReceivedSamples(request).subscribe(
      (result)=>{
        this.blocked = false;
      },
      (error) => {
        this.blocked = false;
        this.showError(error);
      }
    )
  }

  updatePlate() {
    if(!this.isPUIDPresent()){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    this.blocked = true;
    this.platePreparationService.updatePlate(this.selectedPlate.plateID,this.selectedPlate,this.selectedLabId).subscribe({
      next : (result) => {
        this.blocked = false;
        this.selectedPlate = result;
        this.prepareProcessStepsMap();
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Plate '+this.selectedPlate.plateID+' is updated',
          detail: this.selectedPlate.plateID + ' has been updated successfully!'
        })
      },  error: (error: any) => {
        this.blocked = false;
        this.showError(error);
      }
    })

  }

  showPlateInfo(event) {
    this.searchForPlateAction(event.data.plateID);
  }

  removePlateSelection(event){
    this.selectedPlateStepsMap.clear();
    let listIndex = this.validatePlate(event.data.plateID)
    if(listIndex != -1){
      this.plateSelectionList.splice(listIndex,1);
    }
    this.selectedPlateMap.delete(event.data.plateID);
    this.selectedPlate = new Plate();
  }

  searchForPlateAction(plateID: string, addToList: boolean = true){
    this.blocked = true;
    if(!addToList){
      this.selectedPlateMap.clear();
      this.plateSelectionList = [];
    }
    if (this.validatePlate(plateID) != -1) {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: plateID + ' is Duplicated',
        detail: 'Please give the valid Plate-ID',
      });
      this.blocked = false;
      return;
    }
    this.platePreparationService.fetchPlate(plateID,this.selectedLabId).subscribe(
      (result) => {
        this.blocked = false;
        if(this.plateSelectionList.length > 0 && this.selectedPlateStatus !== result.status){
          this._messagesService.addWarningMessage({
            severity: 'warn', summary:result.status +' is Selected',
            detail: ' Please select a plate with the status '+this.selectedPlateStatus,
           });
          return;
        }

        this.selectedPlate = result;
        this.selectedPlateStatus = this.selectedPlate.status;

        this.plateSelectionList.unshift(this.selectedPlate.plateID);
        this.selectedPlateMap.set(this.selectedPlate.plateID, this.selectedPlate.samples);

        this.prepareProcessStepsMap();
        this.plateToSearch = "";
        this.receivePlatePlateID = "";
      }, (error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch plate info',
          detail: error.error
        })
      }
    )
  }

  prepareProcessStepsMap() {
    this.selectedPlateStepsMap.clear();
    if(!this.selectedPlate.processSteps || this.selectedPlate.processSteps==null)
      return;
    this.selectedPlate.processSteps.forEach(step => {
      this.selectedPlateStepsMap.set(step.step, step);
    })
  }

  isValidProcessStep(stepName: string): boolean {
    return (this.selectedPlateStepsMap.get(stepName) != undefined && this.selectedPlateStepsMap.get(stepName) != null);
  }

  getProcessStepStartPuid(stepName: string): string {
    return this.selectedPlateStepsMap.get(stepName).startPUID;
  }

  getProcessStepStartTimestamp(stepName: string): Date {
    return this.convertUtcToLocal(this.selectedPlateStepsMap.get(stepName).startTimeStamp);
  }

  convertUtcToLocal(date: Date): Date{
    if(!date || date==null) return;
    var offset = new Date().getTimezoneOffset();
    let dateInLocal = new Date(date);
    dateInLocal.setMinutes(dateInLocal.getMinutes()-offset);
    return dateInLocal;
  }

  searchForPlate() {
    if(!this.plateToSearch || this.plateToSearch===''){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Please enter a plateID',
        detail: 'Plate ID cannot be empty, please enter something to search'
      })
      return;
    }
    this.searchForPlateAction(this.plateToSearch, false);
  }

  searchForSample() {
    if(!this.sampleToSearch && this.sampleToSearch===''){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Enter sample ID to search',
        detail: 'Please enter something to search'
      })
      return;
    }
    this.blocked = true
    this.announcementService.getSampleFromDelivery(this.selectedLabId,this.sampleToSearch).subscribe({next : (result) => {
      let sample = result.data[0]
      let sample_id = sample['_id']
      this.platePreparationService.fetchPlateBySample(sample_id, this.selectedLabId).subscribe(
        (result)=>{
          this.blocked = false
          this._messagesService.addSuccessMessage({
            severity: 'success', detail: 'Sample search success!'
          })
          this.selectedPlate = result;
          this.prepareProcessStepsMap();
        },
        (error) => {
          this.blocked = false;
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Failed to fetch plate info',
            detail: error.error.error
          })
        }
      )
   },
   error: (error: any) => {
     this.blocked = false;
     this._messagesService.addErrorMessage({
       severity: 'error', summary: 'Failed to fetch plate info',
       detail: error.error.error
     })
   }})
  }

  clearAllFieldsForNewPlate() {
    this.selectedPlate.samples.length= null;
    this.plateToSearch="";
    this.sampleToSearch="";
    this.selectedPlate.workFlow = '';
    this.selectedPlate.sender = '';
    this.selectedPlate.delivery = '';
    this.selectedPlate.plateID='';
    this.selectedPlate.status='';
    this.selectedPlateStepsMap.clear();
    this.selectedPlateMap.clear();
    this.selectedPlateStatus = "";
    this.plateSelectionList = [];
    this.receivePlatePlateID = "";
  }

 isScanElementDisabled() {
    return false;
  }

  showError(error: any) {
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  onTabChange(event) {
    this.index = event.index;
    this.isICBFWorkflow();
  }

  receiveButtonDisable(){
    if(this.selectedPlate.plateID == '' || this.selectedPlate.workFlow == '' || this.selectedPlate.workFlow == null || this.selectedPlate.sender == '' || this.selectedPlate.sender == null || this.selectedPlate.status != 'ANNOUNCED'){
        return true;
    }else{
      return false;
    }
  }

  getStorageLocations() {
    this._maStorageService.fetchActiveStorageLocations(this.selectedLabId, "RECEPTION").subscribe(
      (result) => {
        this.storageList = result.datalist;
        if(this.storageList.length === 1){
          this.selectedStorage = this.storageList[0];
        }
      }
    )
  }

  addPlateToStorage(){
    if(this.selectedPlate.plateID==undefined || this.selectedPlate.plateID==null || this.selectedPlate.plateID==''){
      return;
    }
    this._maStorageService.searchStorageByPlate(this.selectedLabId, this.selectedPlate.plateID).subscribe(
      (result) => {
        if(result.storageName != undefined){
          this._messagesService.addWarningMessage({
            severity: 'warn', summary: 'Plate Already Stored',
            detail: this.selectedPlate.plateID+" already present in "+result.storageName
          });
          return;
        }
      },
      (error) =>{
        let plateData = {};
        plateData['labid'] = this.selectedLabId;
        plateData['plateid'] = this.selectedPlate.plateID;
        plateData['storageName'] = this.selectedStorage['storageName'];
        this._maStorageService.addPlateToStorage(plateData).subscribe(
          (result) => {
            this._messagesService.addSuccessMessage({
              severity: 'success', summary: 'Plate Added Successfully',
              detail: this.selectedPlate.plateID+" added successfully to storage "+this.selectedStorage['storageName']
            });
          },
          (error) => {
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Plate Not Added',
              detail: error.error
            });
          }
        );
      }
    )
  }

  validatePlate(plateToSearch){
    let index = -1;
    for(let i=0; i<this.plateSelectionList.length; i++){
      if(this.plateSelectionList[i] === plateToSearch.trim()){
        index = i;
        break;
      }
    }
     return index;
  }

  deleteValue(index, plateID){
    this.plateSelectionList.splice(index,1);
    this.selectedPlateMap.delete(plateID);
  }

  getMultiUpdateDto() {
    this.plateList = [];
    this.selectedPlateMap.forEach((_value: Sample[], key: string) => {
      this.plateList.push(key)
    });
    let multiPlateUpdate: MultiPlateUpdate = new MultiPlateUpdate();
    multiPlateUpdate.action = "";
    multiPlateUpdate.plateids = this.plateList;
    multiPlateUpdate.plateUpdateInfoList = [];
    multiPlateUpdate.step = ProcessStep.RECEIVE_PLATE;
    multiPlateUpdate.labid = this.selectedLabId;
    multiPlateUpdate.puid = this.puid;
    multiPlateUpdate.liquidHandler = "";
    multiPlateUpdate.status = PlateStatus.RECEIVED;
    multiPlateUpdate.workFlow = this.selectedPlate.workFlow;
    multiPlateUpdate.sender = this.selectedPlate.sender;
    multiPlateUpdate.actionRunTime = 0;
    return multiPlateUpdate;
  }

  updateMultiPlates(){
    if(!this.isPUIDPresent()){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    this.blocked = true;
    let multiUpdateDto = this.getMultiUpdateDto();
    this.platePreparationService.updateStartProcessForMultiplePlates(multiUpdateDto).subscribe(
      (_result) => {
        this.blocked = false;
        this.prepareProcessStepsMap();
        if(this.selectedPlate.workFlow == "OFH"){
          this.updateOFHSamples();
        }
        this.selectedPlateMap.clear();
        this.plateSelectionList = [];
        this.selectedPlate.delivery = null;
        this.selectedPlateStatus = '';
        this.selectedPlateStepsMap.get("RECEIVE_PLATE").startTimeStamp = null;
        this.selectedPlateStepsMap.get("RECEIVE_PLATE").startPUID = null;
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Plates are updated',
          detail: 'Plates has been updated successfully!'
        })
      }, (error) => {
        this.blocked = false;
        this.showError(error);
      })
  }


  receiptReport() {
    this.blocked = true;
    this.platePreparationService.receiptReportDownload(this.selectedLabId, this.dateSelected, this.exported).subscribe({
      next: (receiptReportFile) => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Receipt report Generated Successfully',
          detail: "Receipt report downloaded successfully"
        });
        saveByFileSaver(receiptReportFile.fileContent, receiptReportFile.filename);
      },
      error: (_error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Receipt Report generation failed!!',
          detail: "All Samples Already Exported"
        });
      }
    })
  }

  fetchStoragePlatesList() {
    this.blocked = true;
    this.platePreparationService.fetchStoragePlates(this.selectedLabId).subscribe(
      (result) => {
        this.blocked = false;
        let storagePlatesList = result;
        if(storagePlatesList.length == 0){
          return;
        }
        let storagePlateIDs = [];
        let storageSampleIds = [];
        storagePlatesList.forEach(plate => {
          storagePlateIDs.push(plate.plateID)
          plate.samples.forEach(element => {
            if (element._id != null || element._id != undefined) {
              storageSampleIds.push(element._id)
            }
          });
        });
        this.fetchStorageNamewithPlateID(storagePlateIDs, storageSampleIds);
      },
      (error) => {
        this.blocked = false;
        this._messagesService.addWarningMessage({
          severity: 'error', summary: 'Failed to fetch storage plates',
          detail: 'Some issue in pulling the storage plates info, please try again'
        })
      }
    )
  }


  fetchStorageNamewithPlateID(storagePlateIDs, storageSampleIds) {
    this.blocked = true;
    this._maStorageService.getStorageListByPlateList(this.selectedLabId, storagePlateIDs).subscribe({next : (result) => {
        this.blocked = false;
        this.storagePlateAndStorageLocation = result.data;
        this.fetchSampleInfoBySampleId(storageSampleIds);
      },
      error: (error: any) => {
        this.blocked = false;
        this._messagesService.addWarningMessage({
          severity: 'error', summary: 'Failed to Storage location',
          detail: 'Some issue in pulling the Storage Location, please try again'
        })
      }
    })
  }

  fetchSampleInfoBySampleId(storageSampleIds) {
    this.blocked = true;
    this.announcementService.getSampleInfoBySampleId(this.selectedLabId, storageSampleIds).subscribe(
      (result) => {
        this.blocked = false;
        this.updatedSamplesInfo = result.data;
        if (this.updatedSamplesInfo && this.updatedSamplesInfo.length == 0) {
         return;
        }
        this.activatedSamplesHeaderVisible = true
        this.activatedSamplesData()
      },
      (error) => {
        this.blocked = false;
        this._messagesService.addWarningMessage({
          severity: 'error', summary: 'Failed to fetch Storage Samples',
          detail: 'Some issue in pulling the Storage Samples, please try again'
        })
      }
    )
  }

  activatedSamplesData() {
    this.updatedAnnouncedSamples = [];
    this.updatedSamplesInfo.forEach(sample => {
      let alreadyAnnouncedSamplesDTO = new AlreadyAnnouncedSamplesDTO();
      alreadyAnnouncedSamplesDTO.barCode = sample.barCode;
      alreadyAnnouncedSamplesDTO.position = sample.plateHistory[sample.plateHistory.length - 1].position;
      alreadyAnnouncedSamplesDTO.plateID = sample.plateHistory[sample.plateHistory.length - 1].plateId;
      alreadyAnnouncedSamplesDTO.storagePosition = this.storagePlateAndStorageLocation[sample.plateHistory[sample.plateHistory.length - 1].plateId];
      this.updatedAnnouncedSamples.push(alreadyAnnouncedSamplesDTO);
    });
  }

  downloadExcelFile() {
    const date = new Date();
    let currentDate = `${date.getDate()}_${date.getMonth()+1}_${date.getFullYear()}`;
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.updatedAnnouncedSamples);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    saveByFileSaver(blob, 'ActivatedSamples_'+currentDate+'.xlsx');
  }

  downloadSRCExcel() {
    this.announcementService.getRemovedSRCSamplesData(this.selectedLabId).subscribe({
      next : (result) => {
        this.generateFailedSRCExcelFile(this.convertIntoListOfSRCSampleDTO(result.data), "Failed Samples")
      },
      error: (error: any) => {
        this._messagesService.addWarningMessage({
          severity: 'error', summary: 'Dowload Failed',
          detail: 'Please try again.'
        })
      }
    });
  }

  convertIntoListOfSRCSampleDTO(sampleData: any[]): SRCSampleDTO[] {
    let srcSampleDTOList: SRCSampleDTO[] = [];
    sampleData.forEach(sample => {
      let srcSample = new SRCSampleDTO();
      srcSample.barcode = sample['barCode'];
      srcSample.bottomBarcode = sample['bottomBarcode'];
      srcSample.removed = sample['receptionStatus'];
      srcSample.trayID = sample['srcPlateID'];
      srcSampleDTOList.push(srcSample);
    });
    return srcSampleDTOList;
  }

  generateFailedSRCExcelFile(fileData: SRCSampleDTO[], fileName: string) {
    const date = new Date();
    let currentDate = `${date.getDate()}_${date.getMonth()+1}_${date.getFullYear()}`;
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(fileData);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    saveByFileSaver(blob, fileName+' '+currentDate+'.xlsx');
  }

  getCSSClassForPanel(tab: string){
    if(tab == "plateReception" && this.index == 0){
      return 'selected';
    }else{
      if(this.isPlateReceptionOn && this.index == 1){
        return 'selected';
      }

      if(!this.isPlateReceptionOn && this.index == 0){
        return 'selected';
      }
    }
    return 'unselected';
  }
}
